export default {
    bind: function (el, binding) {
        const tooltipEl = window.$(el);
        tooltipEl.tooltip && tooltipEl.tooltip({
            title: binding.value.title,
            placement: binding.value.placement
        });
    }
}